module.exports = __webpack_public_path__ + "static/example-image-8-91556daba65bb169dba0c71254d94e5d.jpg";